import React, { useEffect } from 'react';
import Loader from '../../utils/Loader';
import Certificate from './certificate';
import Order from './order';
import {
	fetchCertificates,
	fetchOrders,
} from '../../redux/settings/settings.actions';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import DefaultLayoutHOC from '../layoutHOC/defaultLayout';
import ProfileTabLinks from '../common/profileTabLinks';

import ListAnimation from '../utils/animations/list';

const History = ({ fetchCertificates, fetchOrders }) => {
	useEffect(() => {
		Loader.hide();
		fetchCertificates();
		fetchOrders();
		document.getElementById('profileHeader').classList.add('profilepageheader');
		return () => {
			document
				.getElementById('profileHeader')
				.classList.remove('profilepageheader');
		};
	}, [fetchCertificates, fetchOrders]);

	return (
		<div className="settingsContainer">
			{window.outerWidth > 768 ? (
				<ProfileTabLinks />
			) : (
				<h4 className="section-body-title">History</h4>
			)}
			<ListAnimation open={true} className="profile_page_accordion ">
				<Certificate />
				<Order />
			</ListAnimation>
		</div>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchCertificates: () => dispatch(fetchCertificates()),
		fetchOrders: () => dispatch(fetchOrders()),
	};
};

export default withRouter(
	compose(connect(null, mapDispatchToProps), DefaultLayoutHOC)(History),
);
